import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const resetAuthFactors = userId =>
  call(websocketFetch, 'reset_member_mfa_factors', { user_id: userId });
